import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './styles.css'

// utils

const periods = {
    MORNING: 'MORNING',
    AFTERNOON: 'AFTERNOON',
    NIGHT: 'NIGHT',
    DAWN: 'DAWN',
}

const periodToText = {
    [periods.MORNING]: 'M',
    [periods.AFTERNOON]: 'T',
    [periods.NIGHT]: 'N',
    [periods.DAWN]: 'Md',
}

const periodToModifier = {
    [periods.MORNING]: 'morning',
    [periods.AFTERNOON]: 'afternoon',
    [periods.NIGHT]: 'night',
    [periods.DAWN]: 'dawn',
}

class PeriodSymbol extends Component {
    render() {
        const { period, className } = this.props

        return (
            <span className={`PeriodSymbol PeriodSymbol--${periodToModifier[period]} ${className || ''}`}>
                {periodToText[period]}
            </span>
        )
    }
}

PeriodSymbol.propTypes = {
    period: PropTypes.string.isRequired,
    className: PropTypes.string,
}

export default PeriodSymbol
